import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  FormControl, InputLabel, Select, MenuItem, Box, Modal,
  TextField,
  Table, AppBar, Toolbar, Paper, Typography, Tooltip,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditCity = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [cityName, setCityName] = useState('');
  const [stateId, setStateId] = useState('');
  const [countryId, setCountryId] = useState('');
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [CityDetails, setCityDetails] = useState([]);
  const { cityId } = useParams();
  let navigate = useNavigate();

  const handleUpdate = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/City/Id?CityId=${cityId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          "stateId": stateId,
          "countryId": countryId,
          "cityName": cityName
        }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'City has been updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchCityData = async () => {
      try {
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
          `${apiUrl}/City/GetCity`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          const city = responseData.find(city => city.cityId === parseInt(cityId));
          if (city) {
            setCityName(city.cityName);
            setStateId(city.stateId);
            setCountryId(city.countryId);
          } else {
            console.error('City not found for the given ID');
            // alert('City not found');
            setSnackbarMessage('City not found');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
          }
          setLoadingBarProgress(100);
        } else {
          console.error('Failed to fetch city data');
          // alert('Failed to fetch city data');
           setSnackbarMessage('Failed to fetch city data');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        // alert('An error occurred. Please try again later.');
        setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };

    fetchCityData(); // Fetch city data when the component mounts
  }, [cityId]);

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
          `${apiUrl}/Country/GetCountry`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          setCountryData(responseData);
          setLoadingBarProgress(100);
        } else {
          console.error('Account name incorrect');
          // alert('Invalid account name');
          setSnackbarMessage('Invalid account name');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        // alert('An error occurred. Please try again later.');
         setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };

    fetchCountryData(); // Fetch country data when the component mounts
  }, []);

  useEffect(() => {
    const fetchStateData = async () => {
      try {
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
          `${apiUrl}/State/GetState`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          setStateData(responseData);
          setLoadingBarProgress(100);
        } else {
          console.error('Account name incorrect');
          // alert('Invalid account name');
          setSnackbarMessage('Invalid account name');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        // alert('An error occurred. Please try again later.');
        setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };

    fetchStateData(); // Fetch country data when the component mounts
  }, []);

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit City
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="country">Country:</InputLabel>
            <Select
              id="country"
              value={countryId}
              label="Country"
             onChange={(e) => {
    setCountryId(e.target.value);
    setStateId(''); // reset state selection on manual change
  }}
            >
              {countryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        <FormControl fullWidth sx={{ my: 2 }}>
  <InputLabel htmlFor="state">State:</InputLabel>
  <Select
    id="state"
    value={stateId}
    label="State"
    disabled={!countryId}
    onChange={(e) => setStateId(e.target.value)}
  >
    {stateData.filter((stateItem) => String(stateItem.countryId) === String(countryId)).length === 0 ? (
      <MenuItem disabled value="">
        No states available
      </MenuItem>
    ) : (
      stateData
        .filter((stateItem) => String(stateItem.countryId) === String(countryId))
        .map((stateItem) => (
          <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
            {stateItem.stateName}
          </MenuItem>
        ))
    )}
  </Select>
</FormControl>
          <TextField
            label="City Name"
            variant="outlined"
            fullWidth
            value={cityName}
            onChange={(e) => setCityName(e.target.value)}
            sx={{ mb: 3 }}

          />
          <Tooltip title={!cityName && "Enter City Name"} arrow>
            <span><Button
              variant="contained"
              color="primary"
              onClick={handleUpdate}
              sx={{ mr: 2 }}
              disabled={!cityName}
            >
              Update
            </Button></span></Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'City Updated ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'City has been updated successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </Container>
  );
};

export default EditCity;
